/* START_MODULE_CONTRACT
 * PURPOSE: Шаг 3 регистрации: установка пароля и завершение регистрации.
 * SCOPE: React-компонент формы в стиле auth-страниц.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-AUTH, M-REGISTRATION
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * RegisterStepPassword - шаг создания пароля.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-13 - Кастомная форма в стиле auth-страниц вместо MUI.
 * END_CHANGE_SUMMARY
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerConfirm } from '../../api/authApi';

/* START_METHOD_RegisterStepPassword */
/* START_CONTRACT: RegisterStepPassword
 * PURPOSE: Шаг 3 регистрации: установка пароля и завершение регистрации.
 * INPUTS: { email: string }.
 * OUTPUTS: { JSX.Element - форма }.
 * SIDE_EFFECTS: HTTP registerConfirm; навигация на /login.
 * LINKS: M-FE-AUTH, M-REGISTRATION
 * END_CONTRACT: RegisterStepPassword
 */
export default function RegisterStepPassword({ email }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  /* START_METHOD_handleSubmit */
  /* START_CONTRACT: handleSubmit
   * PURPOSE: Завершить регистрацию установкой пароля; при успехе перейти на /login.
   * INPUTS: { e: SubmitEvent }.
   * OUTPUTS: { Promise<void> }.
   * SIDE_EFFECTS: HTTP registerConfirm; navigate('/login'); setError.
   * LINKS: M-REGISTRATION
   * END_CONTRACT: handleSubmit
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await registerConfirm({ email, password });
      navigate('/login');
    } catch (err) {
      setError(
        err.response?.data?.message || 'Ошибка при регистрации',
      );
    } finally {
      setLoading(false);
    }
  };
  /* END_METHOD_handleSubmit */

  return (
    <form onSubmit={handleSubmit} noValidate>
      {error ? (
        <div className="auth-page__alert" role="alert">
          {error}
        </div>
      ) : null}
      <div className="auth-page__field">
        <label className="auth-page__label" htmlFor="register-email-readonly">
          Email
        </label>
        <input
          id="register-email-readonly"
          className="auth-page__input auth-page__input--readonly"
          type="email"
          name="email"
          value={email}
          readOnly
          tabIndex={-1}
          aria-readonly="true"
        />
      </div>
      <div className="auth-page__field">
        <label className="auth-page__label" htmlFor="register-password">
          Пароль
        </label>
        <input
          id="register-password"
          className="auth-page__input"
          type="password"
          name="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
          autoFocus
          required
        />
      </div>
      <button
        type="submit"
        className="auth-page__submit"
        disabled={loading}
      >
        {loading ? 'Регистрация…' : 'Зарегистрироваться'}
      </button>
    </form>
  );
}
/* END_METHOD_RegisterStepPassword */
